<template>
  <div style="overflow-x: auto; max-width: 100%; margin-bottom: 55px">
    <b-alert v-if="hasInconsistentOption" show variant="warning" class="mb-3">
      <strong>Optionsformat uneinheitlich.</strong> Bitte prüfen Sie die Variantenbezeichnungen und speichern Sie die Zeile.
    </b-alert>
    <variant-list-item
        style="min-width: 940px;"
        :variant-index="variantIndex"
        :product-id="productId"
        :options="options"
        :customers="customers"
        :containers="containers"
        v-on="$listeners"
        v-for="(variant, variantIndex) in variants"
        :key="variant.id"
        :variant="variant"
    >
    </variant-list-item>
    <b-button :disabled="inProgress" @click="createVariant" class="ml-2 mb-2 absolute" style="position:absolute; bottom: 2px; left: 8px"><i class="fas fa-plus"></i> Variante hinzufügen</b-button>
  </div>
</template>


<script>

import VariantListItem from "@/pages/EditProductPage/Variants/VariantListItem";
import products from "@/api/products";
export default {
  components: {VariantListItem},
  props: ['variants', 'options', 'productId', 'customers', 'productTitle', 'containers'],
  data(){
    return {
      inProgress: false,
    }
  },
  computed: {
    hasInconsistentOption() {
      if (!this.options || this.options.length === 0) return false
      return this.options.some(opt => opt.name !== 'Title')
    },
    newVariantPayload(){
      let variantTitle = this.productTitle
      let counter = 1
      while (this.variants.map(v => v.title).includes(variantTitle)) {
        variantTitle = this.productTitle + `(${counter})`
        counter += 1;
      }
      return {
        inventoryItem: {
          measurement: {
            weight: {
              value: 0,
              unit: "KILOGRAMS"
            }
          }
        },
        metafields: [
          {
            namespace: 'reservations',
            key: 'customers',
            type: 'json',
            value: JSON.stringify(['all'])
          }
        ],
        optionValues: [
          {
            optionName: 'Title',
            name: variantTitle
          }
        ]
      }
    },
  },
  methods: {
    createVariant(){
      this.inProgress = true;
      products.addVariant(
          this.productId,
          this.newVariantPayload
      ).then(
          (response) => {
            this.$emit('variant-created', response.data)
          }
      ).finally(
          () => this.inProgress = false
      ).catch(
          () => this.$bvModal.show('error-modal')
      )
    }
  }
}
</script>

